/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

var withInstall = function withInstall(comp) {
  var c = comp;

  c.install = function (app, name) {
    app.component(name || c.componentName || c.name, comp);
  };

  return comp;
};

export { withInstall };
//# sourceMappingURL=withInstall.js.map
